var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNothingFoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.5964 48.9048C90.8016 50.1708 91.2516 51.354 91.8912 52.4088V90.912H84.072V60.5088H68.862L71.6232 64.602L78.6024 63.1488L80.5764 72.63L63.048 76.278L61.074 66.7968L66.726 65.6208L67.3764 60.5088H56.7408V90.912H31.0488V52.4076C31.6896 51.354 32.1384 50.1708 32.3436 48.9048C33.1056 53.58 37.1616 57.1512 42.0516 57.1512C46.9428 57.1512 51 53.58 51.7608 48.9048C52.5216 53.58 56.5788 57.1512 61.4688 57.1512C66.36 57.1512 70.416 53.58 71.178 48.9048C71.94 53.58 75.996 57.1512 80.8872 57.1512C85.7784 57.1512 89.8344 53.58 90.5964 48.9048ZM24.204 57.0252C23.6928 57.1068 23.1684 57.1512 22.6344 57.1512C17.2008 57.1512 12.7956 52.746 12.7956 47.3124L26.496 23.4312H96.4428L110.144 47.3124C110.144 52.746 105.738 57.1512 100.306 57.1512C99.7716 57.1512 99.2472 57.1068 98.7348 57.0252V90.912H111.431C116.87 81.882 120 71.3076 120 60C120 26.8632 93.1356 0 60 0C26.8632 0 0 26.8632 0 60C0 71.3076 3.1296 81.8832 8.568 90.912H24.204V57.0252ZM60 120C77.5656 120 93.3696 112.45 104.342 100.418H15.6576C26.6304 112.45 42.4332 120 60 120Z",
    fill: "#D0DBE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingFoundIcon);
export default __webpack_public_path__ + "static/media/nothing_found_icon.b6549af700e9bb66ac1680a6b2b6dcfd.svg";
export { ForwardRef as ReactComponent };